// extracted by mini-css-extract-plugin
export var card = "TwoColumnImageWithCards-module--card--37ef2";
export var cards = "TwoColumnImageWithCards-module--cards--298bc";
export var columns = "TwoColumnImageWithCards-module--columns--05b0a";
export var divider = "TwoColumnImageWithCards-module--divider--ac85a";
export var emerald = "TwoColumnImageWithCards-module--emerald--1c709";
export var fadeIn = "TwoColumnImageWithCards-module--fadeIn--61dcd";
export var grey = "TwoColumnImageWithCards-module--grey--280a8";
export var image = "TwoColumnImageWithCards-module--image--0801a";
export var lilac = "TwoColumnImageWithCards-module--lilac--152db";
export var pink = "TwoColumnImageWithCards-module--pink--9aa17";
export var section = "TwoColumnImageWithCards-module--section--f77b3";
export var visible = "TwoColumnImageWithCards-module--visible--19317";